const initialState = {
	userdata_id: null,
	userdata_id_code: null,
	userdata_name: null,
	userdata_sex: null,
	userdata_opposite_sex: null,
	userdata_age: null,
	userdata_mainImg: null,
	userdata_img_restriction: null,
	userdata_birthday: '19700615',
	userdata_search: null,
	userdata_couple: null,
	userdata_couple_code: null,
	userdata_proof_income: null,
	userdata_proof_single: null,
	userdata_proof_credit: null,
	userdata_proof_person: null,
	userdata_proof_photo: null,
	userdata_proof_check: null,
	userdata_profile_check: null,
	userdata_profile_webmaster_check: 0,
	userdata_affiliate_send_check: null,
	userdata_profile_open: null,
	userdata_charge_service_start_date: null,
	userdata_charge_service_end_date: null,
	userdata_credit_automatic_flag: null,
	userdata_auto_mail_notification_flag: null,
	userdata_member_notification_flag: null,
	userdata_favorite_notification_flag: null,
	userdata_creditcard_name: null,
	userdata_not_match_important_mail: null,
	userdata_not_match_important_search: null,
	userdata_want_proof_credit: null,
	userdata_want_proof_person: null,
	userdata_want_proof_photo: null,
	userdata_want_proof_income: null,
	userdata_want_proof_single: null,
	userdata_prof_region: '',
	userdata_prof_region_detail: '',
	userdata_prof_region_detail_hidden: 0,
	userdata_lat: '',
	userdata_lon: '',
	userdata_prof_job: '',
	userdata_prof_child: '',
	userdata_prof_style: '',
	userdata_prof_height: '',
	userdata_prof_smorking: '',
	userdata_prof_drinking: '',
	userdata_prof_gambling: '',
	userdata_prof_pet: '',
	userdata_prof_birthplace: '',
	userdata_prof_birthplace_detail: '',
	userdata_prof_relationship: '',
	userdata_prof_religion: '',
	userdata_prof_house: '',
	userdata_prof_car: '',
	userdata_prof_holiday: '',
	userdata_prof_blood: '',
	userdata_prof_academic: '',
	userdata_prof_marriage: '',
	userdata_prof_constellation: '',
	userdata_prof_lifestyle: '',
	userdata_prof_association: '',
	userdata_prof_income: '',
	userdata_prof_status: '',
	userdata_prof_partner_region: '',
	userdata_prof_partner_age_low: 18,
	userdata_prof_partner_age_high: 90,
	userdata_prof_partner_style: '',
	userdata_prof_partner_height_low: 120,
	userdata_prof_partner_height_high: 230,
	userdata_prof_partner_job: '',
	userdata_prof_partner_association: '',
	userdata_prof_partner_marriage: '',
	userdata_prof_partner_child: '',
	userdata_prof_partner_lifestyle: '',
	userdata_prof_partner_blood: '',
	userdata_prof_partner_academic: '',
	userdata_prof_partner_income: '',
	userdata_prof_partner_smorking: '',
	userdata_prof_partner_drinking: '',
	userdata_prof_partner_gambling: '',
	userdata_prof_partner_pet: '',
	userdata_prof_partner_region_important: 0,
	userdata_prof_partner_height_important: 0,
	userdata_prof_partner_age_important: 0,
	userdata_prof_partner_style_important: 0,
	userdata_prof_partner_job_important: 0,
	userdata_prof_partner_association_important: 0,
	userdata_prof_partner_marriage_important: 0,
	userdata_prof_partner_child_important: 0,
	userdata_prof_partner_lifestyle_important: 0,
	userdata_prof_partner_academic_important: 0,
	userdata_prof_partner_income_important: 0,
	userdata_prof_partner_smorking_important: 0,
	userdata_prof_partner_drinking_important: 0,
	userdata_prof_partner_gambling_important: 0,
	userdata_prof_partner_pet_important: 0,
	userdata_prof_comment: '',
	userdata_prof_partner_comment: '',
	character_diagnosis_EI: null,
	character_diagnosis_SN: null,
	character_diagnosis_TF: null,
	character_diagnosis_JP: null,
	character_diagnosis_MBTI: null,
	character_diagnosis_check: null,
	post_count: 0,
	qa_answer_count: 0,
	qa_question_count: 0,
	datetime: null,
};

export default function reducer(state = initialState, action) {

	if (action.type === 'MY_PROFILE_SET') {

		let profile = action.payload;

		let newState = {
			userdata_id: profile.userdata_id,
			userdata_id_code: profile.userdata_id_code,
			userdata_name: profile.userdata_name,
			userdata_sex: profile.userdata_sex,
			userdata_opposite_sex: profile.userdata_opposite_sex,
			userdata_age: Number(profile.userdata_age),
			userdata_mainImg: profile.userdata_mainImg,
			userdata_img_restriction: profile.userdata_img_restriction,
			userdata_birthday: profile.userdata_birthday,
			userdata_search: profile.userdata_serch,
			userdata_couple: profile.userdata_couple,
			userdata_couple_code: profile.userdata_couple_code,
			userdata_proof_income: profile.userdata_proof_income,
			userdata_proof_single: profile.userdata_proof_single,
			userdata_proof_credit: profile.userdata_proof_credit,
			userdata_proof_person: profile.userdata_proof_person,
			userdata_proof_photo: profile.userdata_proof_photo,
			userdata_proof_check: profile.userdata_proof_check,
			userdata_profile_check: profile.userdata_profile_check,
			userdata_profile_webmaster_check: profile.userdata_profile_webmaster_check,
			userdata_affiliate_send_check: profile.userdata_affiliate_send_check,
			userdata_profile_open: profile.userdata_profile_open,
			userdata_charge_service_start_date: profile.userdata_charge_service_start_date,
			userdata_charge_service_end_date: profile.userdata_charge_service_end_date,
			userdata_credit_automatic_flag: profile.userdata_credit_automatic_flag,
			userdata_auto_mail_notification_flag: profile.userdata_auto_mail_notification_flag,
			userdata_member_notification_flag: profile.userdata_member_notification_flag,
			userdata_favorite_notification_flag: profile.userdata_favorite_notification_flag,
			userdata_creditcard_name: profile.userdata_creditcard_name,
			userdata_not_match_important_mail: profile.userdata_not_match_important_mail,
			userdata_not_match_important_search: profile.userdata_not_match_important_search,
			userdata_want_proof_credit: profile.userdata_want_proof_credit,
			userdata_want_proof_person: profile.userdata_want_proof_person,
			userdata_want_proof_photo: profile.userdata_want_proof_photo,
			userdata_want_proof_income: profile.userdata_want_proof_income,
			userdata_want_proof_single: profile.userdata_want_proof_single,
			userdata_prof_region: profile.userdata_prof_region,
			userdata_prof_region_detail: profile.userdata_prof_region_detail,
			userdata_prof_region_detail_hidden: profile.userdata_prof_region_detail_hidden,
			userdata_lat: profile.userdata_lat,
			userdata_lon: profile.userdata_lon,
			userdata_prof_job: profile.userdata_prof_job,
			userdata_prof_child: profile.userdata_prof_child,
			userdata_prof_style: profile.userdata_prof_style,
			userdata_prof_height: profile.userdata_prof_height,
			userdata_prof_smorking: profile.userdata_prof_smorking,
			userdata_prof_drinking: profile.userdata_prof_drinking,
			userdata_prof_gambling: profile.userdata_prof_gambling,
			userdata_prof_pet: profile.userdata_prof_pet,
			userdata_prof_birthplace: profile.userdata_prof_birthplace,
			userdata_prof_birthplace_detail: profile.userdata_prof_birthplace_detail,
			userdata_prof_relationship: profile.userdata_prof_relationship,
			userdata_prof_religion: profile.userdata_prof_religion,
			userdata_prof_house: profile.userdata_prof_house,
			userdata_prof_car: profile.userdata_prof_car,
			userdata_prof_holiday: profile.userdata_prof_holiday,
			userdata_prof_blood: profile.userdata_prof_blood,
			userdata_prof_academic: profile.userdata_prof_academic,
			userdata_prof_marriage: profile.userdata_prof_marriage,
			userdata_prof_constellation: profile.userdata_prof_constellation,
			userdata_prof_lifestyle: profile.userdata_prof_lifestyle,
			userdata_prof_association: profile.userdata_prof_association,
			userdata_prof_income: profile.userdata_prof_income,
			userdata_prof_status: profile.userdata_prof_status,
			userdata_prof_partner_region: profile.userdata_prof_partner_region,
			userdata_prof_partner_age_low: Number(profile.userdata_prof_partner_age_low),
			userdata_prof_partner_age_high: Number(profile.userdata_prof_partner_age_high),
			userdata_prof_partner_style: profile.userdata_prof_partner_style,
			userdata_prof_partner_height_low: Number(profile.userdata_prof_partner_height_low),
			userdata_prof_partner_height_high: Number(profile.userdata_prof_partner_height_high),
			userdata_prof_partner_job: profile.userdata_prof_partner_job,
			userdata_prof_partner_association: profile.userdata_prof_partner_association,
			userdata_prof_partner_marriage: profile.userdata_prof_partner_marriage,
			userdata_prof_partner_child: profile.userdata_prof_partner_child,
			userdata_prof_partner_lifestyle: profile.userdata_prof_partner_lifestyle,
			userdata_prof_partner_blood: profile.userdata_prof_partner_blood,
			userdata_prof_partner_academic: profile.userdata_prof_partner_academic,
			userdata_prof_partner_income: profile.userdata_prof_partner_income,
			userdata_prof_partner_smorking: profile.userdata_prof_partner_smorking,
			userdata_prof_partner_drinking: profile.userdata_prof_partner_drinking,
			userdata_prof_partner_gambling: profile.userdata_prof_partner_gambling,
			userdata_prof_partner_pet: profile.userdata_prof_partner_pet,
			userdata_prof_partner_region_important: profile.userdata_prof_partner_region_important,
			userdata_prof_partner_height_important: profile.userdata_prof_partner_height_important,
			userdata_prof_partner_age_important: profile.userdata_prof_partner_age_important,
			userdata_prof_partner_style_important: profile.userdata_prof_partner_style_important,
			userdata_prof_partner_job_important: profile.userdata_prof_partner_job_important,
			userdata_prof_partner_association_important: profile.userdata_prof_partner_association_important,
			userdata_prof_partner_marriage_important: profile.userdata_prof_partner_marriage_important,
			userdata_prof_partner_child_important: profile.userdata_prof_partner_child_important,
			userdata_prof_partner_lifestyle_important: profile.userdata_prof_partner_lifestyle_important,
			userdata_prof_partner_academic_important: profile.userdata_prof_partner_academic_important,
			userdata_prof_partner_income_important: profile.userdata_prof_partner_income_important,
			userdata_prof_partner_smorking_important: profile.userdata_prof_partner_smorking_important,
			userdata_prof_partner_drinking_important: profile.userdata_prof_partner_drinking_important,
			userdata_prof_partner_gambling_important: profile.userdata_prof_partner_gambling_important,
			userdata_prof_partner_pet_important: profile.userdata_prof_partner_pet_important,
			userdata_prof_comment: profile.userdata_prof_comment,
			userdata_prof_partner_comment: profile.userdata_prof_partner_comment,
			character_diagnosis_EI: profile.character_diagnosis_EI,
			character_diagnosis_SN: profile.character_diagnosis_SN,
			character_diagnosis_TF: profile.character_diagnosis_TF,
			character_diagnosis_JP: profile.character_diagnosis_JP,
			character_diagnosis_MBTI: profile.character_diagnosis_MBTI,
			character_diagnosis_check: profile.character_diagnosis_check,
			post_count: profile.post_count,
			qa_answer_count: profile.qa_answer_count,
			qa_question_count: profile.qa_question_count,
			datetime: (new Date()),
		}
		return newState;
	}
	else if (action.type === 'MY_PROFILE_DATETIME_INIT') {
		let newState = Object.assign({}, state);
		newState.datetime = null;
		return newState;
	}
	else {
		return state;
	}
}
